<!--
/**
* @name: List.vue
* @description: 返利管理-返利规则查询列表页面
* @author: 杨波
* @create: 2020/11/19 17:06:58
* @update: 2020/11/19 17:06:58
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入返利活动名称" clearable v-model="para.rebateRuleName"></k-input>
      </y-query-item>
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入商品货号" clearable v-model="para.goodsCodeSale"></k-input>
      </y-query-item>
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入仓库名称" clearable v-model="para.wsname"></k-input>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入批次号" clearable v-model="para.saleBatchNo"></k-input>
      </y-query-item>
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择门店等级" block clearable v-model="para.shopGrade">
          <k-option v-for="item in shopGradeList" :key="item.value" :value="item.value" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择销售渠道" block clearable v-model="para.saleChannelCode">
          <k-option v-for="item in saleChannelList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择启停用状态" block clearable v-model="para.isDisabled">
          <k-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <DatePicker :editable="false" type="datetimerange" @on-change="changeDate" :value="createDate" format="yyyy-MM-dd HH:mm:ss" placeholder="请选择创建时间" style="width: 280px;"></DatePicker>
      </y-query-item>
      <y-query-item>
        <DatePicker
          :editable="false"
          type="datetimerange"
          @on-change="changeStartDate"
          :value="startTimeRange"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择开始生效时间"
          style="width: 280px;"
        ></DatePicker>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <DatePicker
          :editable="false"
          type="datetimerange"
          @on-change="changeEndDate"
          :value="endTimeRange"
          format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择结束生效时间"
          style="width: 280px;"
        ></DatePicker>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <k-table :data="dataList" :height="$root.tableHeightXXX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" v-if="dataList && dataList.length > 0" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>
<script>
import {
  NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_QUERY,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
  NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_REBATE_RULE_ITEM_DISABLED,
  NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_SALE_CHANNELS,
} from "@/assets/modules/apiList";
const initPara = () => ({
  rebateRuleName: "",
  goodsCodeSale: "",
  wsname: "",
  saleBatchNo: "",
  shopGrade: "",
  saleChannelCode: "",
  isDisabled: "",
  pageCurrent: 1,
  pageSize: 15,
  createStartTime: "",
  createEndTime: "",
});
export default {
  data() {
    return {
      isLoading: false,
      para: initPara(),
      shopGradeList: [], // 门店等级列表
      saleChannelList: [], // 销售渠道列表
      statusList: [
        { value: 1, label: "禁用" },
        { value: 0, label: "启用" },
      ], //启停用状态列表
      dataList: [],
      total: 0,
      createDate: "",
      startTimeRange: "",
      endTimeRange: "",
    };
  },
  methods: {
    changeDate(date) {
      this.createDate = date;
    },
    changeStartDate(date) {
      this.startTimeRange = date;
    },
    changeEndDate(date) {
      this.endTimeRange = date;
    },
    //分页查询操作
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getDataList();
    },
    initColumns() {
      return [
        {
          name: "ID",
          field: "id",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "返利活动名称",
          field: "rebateRuleName",
          style: {
            width: 100,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "商品货号",
          field: "goodsCodeSale",
          style: {
            width: 100,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "仓库名称",
          field: "wsname",
          style: {
            width: 130,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "批次号",
          field: "saleBatchNo",
          style: {
            width: 150,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "门店等级",
          field: "shopGrade",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.shopGradeList.length; i++) {
              if (row.shopGrade == this.shopGradeList[i].value) {
                temp = this.shopGradeList[i].name;
                break;
              }
            }
            return <div>{temp}</div>;
          },
        },
        {
          name: "返利类型",
          field: "rebateTypeDesc",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "返利值",
          field: "rebateValue",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "开始生效时间",
          field: "startTime",
          style: {
            width: 120,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "结束生效时间",
          field: "endTime",
          style: {
            width: 120,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "状态",
          field: "",
          style: {
            width: 80,
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={!row.isDisabled}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
        },
        {
          name: "销售渠道",
          field: "saleChannelName",
          style: {
            width: 100,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "创建时间",
          field: "createTime",
          style: {
            width: 120,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
      ];
    },
    onChangeStatus(row) {
      let { id, status } = row;
      this.$dialog({
        title: "提示",
        content: `是否确认${row.isDisabled == "0" ? "停用" : "启用"}该返利规则？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_REBATE_RULE_ITEM_DISABLED,
            para: { id, isDisabled: row.isDisabled == "1" ? 0 : 1 },
          })
            .then(() => {
              this.isLoading = false;
              this.getDataList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    //获取列表数据
    getDataList() {
      let { para } = this;
      para.createStartTime = this.createDate && this.createDate.length > 0 ? this.createDate[0] : "";
      para.createEndTime = this.createDate && this.createDate.length > 0 ? this.createDate[1] : "";
      para.startStartTime = this.startTimeRange && this.startTimeRange.length > 0 ? this.startTimeRange[0] : "";
      para.startEndTime = this.startTimeRange && this.startTimeRange.length > 0 ? this.startTimeRange[1] : "";
      para.endStartTime = this.endTimeRange && this.endTimeRange.length > 0 ? this.endTimeRange[0] : "";
      para.endEndTime = this.endTimeRange && this.endTimeRange.length > 0 ? this.endTimeRange[1] : "";
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_QUERY,
        para,
      }).then((res) => {
        this.dataList = res.pageList || [];
        this.total = res.total;
      });
    },
    //条件查询
    onSearch() {
      this.para.pageCurrent = 1;
      this.getDataList();
    },
    //重置查询条件
    onReset() {
      this.para = initPara();
      this.createDate = "";
      this.startTimeRange = "";
      this.endTimeRange = "";
      this.getDataList();
    },
    //获取销售渠道信息
    getChannelList() {
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_SALE_CHANNELS,
        para: {},
      }).then((res) => {
        this.saleChannelList = res || [];
      });
    },
    getStoreGradeList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_BY_PARENTCODE,
        para: {
          parentCode: "storeGrade",
        },
      }).then((res) => {
        this.shopGradeList = res || [];
      });
    },
  },
  created() {
    this.getDataList();
    this.getChannelList();
    this.getStoreGradeList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getDataList();
    next();
  },
};
</script>
<style lang="postcss" module="css">
.inputW {
  width: 280px !important;
}
</style>
